/** Below the patch-log modal (9000), above the AppShell navbar (100). */
export const ONBOARDING_MODAL_Z_INDEX = 8500;
